(function () {
  'use strict';

  /**
   * 将 Shopify 产品 ID 转为 GID
   * @param {number|string} productId - 产品 ID
   * @returns {string} gid://shopify/Product/xxx
   */
  function productIdToGid(productId) {
    if (!productId) return '';
    
    const idStr = String(productId);

    if (idStr.startsWith('gid://shopify/Product/')) {
      return idStr;
    }

    const id = idStr.replace(/\D/g, '');
    const gid = id ? `gid://shopify/Product/${id}` : '';
    
    return gid;
  }

  /**
   * 请求折扣接口
   * @param {string} discountId - 折扣 ID（如 "1"）
   * @param {object} options - { baseUrl }
   * @returns {Promise<object>} 标准化后的数据
   */
  async function fetchDiscount(discountId, options = {}) {
    console.log('🔍 BundleApi.fetchDiscount called with ID:', discountId);
    const json = await window.ApiClient.getDiscount(discountId, options);
    console.log('📦 BundleApi received response:', json);
    
    if (json.status !== 200 || !json.data) {
      let errorMsg = 'Invalid discount response';
      if (json.meta && json.meta.message) {
        errorMsg = json.meta.message;
      }
      throw new Error(errorMsg);
    }

    const data = json.data;
    const config = data.config || {};
    const bundles = config.bundles || [];

    if (bundles.length === 0) {
      return {
        id: data.id,
        title: data.title,
        description: data.description,
        primaryBundle: null,
        bundles: []
      };
    }

    const primary = bundles[0];
    const tiers = (primary.tiers || []).map((t) => ({
      minQuantity: t.minQuantity,
      percentage: t.percentage
    }));

    const primaryBundle = {
      id: primary.id,
      name: primary.name,
      description: primary.description || data.description,
      isEnabled: primary.isEnabled !== false,
      isAllProduct: primary.isAllProduct === true,
      products: primary.products || [],
      tiers
    };

    return {
      id: data.id,
      title: data.title,
      description: data.description,
      primaryBundle,
      bundles: bundles.map((b) => ({
        id: b.id,
        name: b.name,
        isAllProduct: b.isAllProduct === true,
        products: b.products || [],
        tiers: (b.tiers || []).map((t) => ({ minQuantity: t.minQuantity, percentage: t.percentage }))
      }))
    };
  }

  /**
   * 获取折扣数据（带简单缓存，5 分钟内复用）
   */
  async function getDiscount(discountId, options = {}) {
    if (!discountId) {
      console.warn('⚠️ getDiscount called without discountId');
      return null;
    }
    console.log('🎯 BundleApi.getDiscount - ID:', discountId, 'Options:', options);
    try {
      const data = await fetchDiscount(discountId, options);
      console.log('✅ Bundle data processed successfully');
      return data;
    } catch (e) {
      console.error('❌ Bundle API getDiscount error:', e);
      return null;
    }
  }

  /**
   * 判断当前页面的产品列表是否与 bundle 产品取交集
   * @param {Array<{id: number|string}>} products - 当前产品列表（含 id）
   * @param {object} primaryBundle - getDiscount 返回的 primaryBundle
   * @returns {boolean} 是否有交集或 isAllProduct
   */
  function productsMatchBundle(products, primaryBundle) {
    if (!primaryBundle) return true;
    if (primaryBundle.isAllProduct) return true;
    const gidSet = new Set(primaryBundle.products || []);
    if (gidSet.size === 0) return true;
    return products.some((p) => gidSet.has(productIdToGid(p.id)));
  }

  /**
   * 过滤产品列表：仅保留在 bundle 产品集合内的（isAllProduct 时不过滤）
   */
  function filterProductsByBundle(products, primaryBundle) {
    console.log('🔧 filterProductsByBundle called:', {
      inputCount: products ? products.length : 0,
      primaryBundle: primaryBundle ? {
        isAllProduct: primaryBundle.isAllProduct,
        productsCount: primaryBundle.products ? primaryBundle.products.length : 0
      } : null
    });
    
    if (!primaryBundle || primaryBundle.isAllProduct) {
      console.log('✅ No filter needed (isAllProduct or no bundle)');
      return products;
    }
    
    const gidSet = new Set(primaryBundle.products || []);
    if (gidSet.size === 0) {
      console.log('✅ No filter needed (empty bundle products)');
      return products;
    }
    
    console.log('🎯 Filtering with bundle GIDs:', Array.from(gidSet).slice(0, 3));
    
    const filtered = products.filter((p) => {
      const gid = productIdToGid(p.id);
      const matches = gidSet.has(gid);
      if (products.indexOf(p) < 3) { // Log first 3 products
        console.log(`  Product ${p.id} -> ${gid}: ${matches ? '✅ MATCH' : '❌ NO MATCH'}`);
      }
      return matches;
    });
    
    console.log('📊 Filter result:', {
      inputCount: products.length,
      outputCount: filtered.length,
      filteredOut: products.length - filtered.length
    });
    
    return filtered;
  }

  window.BundleApi = {
    getDiscount,
    fetchDiscount,
    productIdToGid,
    productsMatchBundle,
    filterProductsByBundle
  };
})();
